import { render, staticRenderFns } from "./shift-delete-modal.vue?vue&type=template&id=bc1ddd7e&scoped=true&lang=pug"
import script from "./shift-delete-modal.vue?vue&type=script&lang=ts"
export * from "./shift-delete-modal.vue?vue&type=script&lang=ts"
import style0 from "./shift-delete-modal.vue?vue&type=style&index=0&id=bc1ddd7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1ddd7e",
  null
  
)

export default component.exports